module.exports = __webpack_public_path__ + "static/media/33000027.00002629.png";